import { styled } from "styled-components";

import { colorCSS, colorContrastCSS, fontSizes } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const PowerUpGrid = styled.div`
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("background-color", `${colorCSS("N0")}`)}
    ${redundantCssFromKebab("border-radius", "0.5rem")}
    ${redundantCssFromKebab("display", "grid")}
    ${redundantCssFromKebab("grid-gap", "1rem")}
    ${redundantCssFromKebab(
        "grid-template-columns",
        "1fr minmax(min-content, 25%)"
    )}
    ${redundantCssFromKebab("height", "100%")}
    ${redundantCssFromKebab("padding", "1rem")}
    ${redundantCssFromKebab("width", "100%")}

    @media (min-width: 576px) {
        ${redundantCssFromKebab(
            "grid-template-columns",
            "80px 1fr minmax(min-content, 25%)"
        )}
    }
`;

export const ImageColumn = styled.div`
    ${redundantCssFromKebab("display", "none")}

    img {
        ${redundantCssFromKebab("height", "auto")}
        ${redundantCssFromKebab("width", "80px")}
    }

    @media (min-width: 576px) {
        ${redundantCssFromKebab("display", "block")}
    }
`;

export const TextColumn = styled.div`
    ${redundantCssFromKebab("color", `${colorContrastCSS("N0")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("text-align", "left")}

    *:last-child {
        ${redundantCssFromKebab("margin-bottom", "0")}
    }
`;

export const CtaColumn = styled.div`
    ${redundantCssFromKebab("justify-self", "flex-end")}
    ${redundantCssFromKebab("text-align", "center")}
`;
